import {
  Box,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { ReactComponent as HashPackLogo } from 'assets/hashpack-logo.svg';
import { ReactComponent as WalletIcon } from 'assets/wallet-icon.svg';
import { useContext } from 'react';
import { GlobalContext } from '../../providers/Global';
import { ModalType } from '../../utils/constants';

const walletItemStyle = {
  h: 76,
  px: 6,
  py: 4,
  cursor: 'pointer',
  borderRadius: 16,
  border: '1px solid #E1E1E1',
  _hover: {
    bg: 'gray.50',
  },
};

const SelectWalletNetworksModal = () => {
  const {
    modals: {
      [`${ModalType.ConnectWalletModal}`]: { open },
    },
    connection: {
      connectToHashPack,
      connectViaWalletConnect,
      isHashPackExtensionAvailable,
    },
    closeModal,
  } = useContext(GlobalContext);

  const handleHashPackClick = () => {
    connectToHashPack();
    closeModal(ModalType.ConnectWalletModal);
  };

  const handleWalletConnectClick = () => {
    connectViaWalletConnect();
    closeModal(ModalType.ConnectWalletModal);
  };

  return (
    <Modal onClose={() => closeModal(ModalType.ConnectWalletModal)} isOpen={open} isCentered>
      <ModalOverlay />
      <ModalContent minWidth="460px">
        <ModalHeader pt={6} px={6} pb={0}>
          <Flex alignItems="center">
            <Text w="100%" align="center" mt={6} size="2xl" variant="bodyBold">
              Connect Wallet
            </Text>
          </Flex>
          <ModalCloseButton color="#565656" mt={2} mr={2} />
        </ModalHeader>
        <ModalBody pt={6} pb={12} px={6}>
          <Flex direction="column" gap={3}>
            {/* HashPack direct option - only shown if extension is available */}
            {isHashPackExtensionAvailable && (
              <Flex
                sx={walletItemStyle}
                onClick={handleHashPackClick}
              >
                <Box display="flex" alignItems="center" flex={1}>
                  <HashPackLogo />
                  <Flex direction="column" ml={4}>
                    <Text fontWeight={600}>HashPack</Text>
                    <Text fontSize="sm" color="gray.500">Browser Extension</Text>
                  </Flex>
                </Box>
              </Flex>
            )}

            {/* WalletConnect option - always available */}
            <Flex
              sx={walletItemStyle}
              onClick={handleWalletConnectClick}
            >
              <Box display="flex" alignItems="center" flex={1}>
                <WalletIcon style={{ width: 40, height: 40 }} />
                <Flex direction="column" ml={4}>
                  <Text fontWeight={600}>WalletConnect</Text>
                  <Text fontSize="sm" color="gray.500">All Wallets</Text>
                </Flex>
              </Box>
            </Flex>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SelectWalletNetworksModal;
